<template>
	<div class="new-business-container">
		<div class="top-bar">
			<div class="navbar-container">
				<TopNavbar ref="top-navbar" base-path="/add-business" >
					<template #content>
						<div class="row navbar-slot-content">
							<div class="navbar-left-side">
								<h3>{{ getString('new_business') }}</h3>
							</div>
							<div class="navbar-right-side">
							</div>
						</div>
					</template>
				</TopNavbar>
			</div>
		</div>
		<div class="content">
			<div class="main-content">
				<AppCard :title="getString('business_data')" :button-text="getString('add')" @button-click="addBusiness">
					<template v-slot:body>
						<AppList :items="itemsForm">
							<template v-slot:input-text="{item}">
								<div class="row list-row">
									<p class="list-item-title">{{ item.title }}</p>
									<AppTextInput class="text-input" :ref="item.ref" :placeholder="item.title" />
								</div>
							</template>
							<template v-slot:input-address="{item}">
								<div class="row centered space-between list-row">
									<p class="list-item-title">{{ item.title }}</p>
									<AppGoogleMapsInput class="text-input" no-map :placeholder="item.title" @changed-address="(a) => address = a" />
								</div>
							</template>
							<template v-slot:input-cards="{item}">
								<div class="row centered space-between list-row">
									<p class="list-item-title cards-list-item-title">{{ item.title }}</p>
									<div class="list-item-content">
										<AppBusinessTypeCard
											:small="windowWidth < 768"
											v-for="typeCard in businessTypeCards"
											@click="businessType = typeCard.value"
											:active="typeCard.value === businessType"
											:title="typeCard.title"
											:imageSrc="typeCard.imageSrc"
											:value="typeCard.value"
										/>
									</div>
								</div>
							</template>
						</AppList>
					</template>
				</AppCard>
			</div>
		</div>
		<AppPopup
			ref="contract-popup"
			:title="getString('accept_contract')"
			:buttons="[{text: getString('cancel'), negative: true, callback: contractFailed}, {text: getString('continue'), loading: loadingNewBusiness, callback: acceptContractClick}]" @toggling-popup="togglingContract" >
			<TermsAndConditions ref="contract-failed" class="mt-10 mb-10" @contract-signed="termAndCondition = true" @contract-unsigned="termAndCondition = false" />
		</AppPopup>
	</div>
</template>

<script>
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/user/stores";
import AppCard from "@/shared/components/AppCard.vue";
import AppList from "@/shared/components/AppList.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppGoogleMapsInput from "@/shared/components/AppGoogleMapsInput.vue";
import AppSelect from "@/shared/components/AppSelect.vue";
import BusinessesSelect from "@/console-new/components/shared/BusinessesSelect.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import TermsAndConditions from "@/console-signup/components/TermsAndConditions.vue";
import API from "@/shared/helpers/API";
import TopNavbar from "@/console-new/components/shared/TopNavbar.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppBusinessTypeCard from "@/shared/components/AppBusinessTypeCard.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {
			getString: languageStore.getString,
			userStore,
			showNotification: notificationStore.showNotification
		};
	},
	name: "NewBusinessContainer",
	mixins: [WindowWidth],
	components: {
		AppButtonIcon,
		AppBusinessTypeCard,
		AppSwitch,
		TopNavbar,
		TermsAndConditions, AppPopup, BusinessesSelect, AppSelect, AppGoogleMapsInput, AppTextInput, AppList, AppCard},
	data() {
		return {
			address: null,
			copyOption: false,
			termAndCondition: false,
			loadingNewBusiness: false,
			businessType: null,
		}
	},
	computed: {
		businessTypeCards() {
			return [
				{title: this.getString('business_type_food'), value: "restaurant", imageSrc: "https://qromomilan.s3.eu-south-1.amazonaws.com/img/signup-card-food-beverage.jpeg"},
				{title: this.getString('business_type_events'), value: "events", imageSrc: "https://qromomilan.s3.eu-south-1.amazonaws.com/img/signup-card-events.jpeg"},
				{title: this.getString('business_type_retail'), value: "other", imageSrc: "https://qromomilan.s3.eu-south-1.amazonaws.com/img/signup-card-retail.jpeg"}
			];
		},
		itemsForm() {
			return [
				{title: this.getString("business_name"), ref: 'business-name', customSlot: 'input-text'},
				{title: this.getString("business_address"), customSlot: 'input-address'},
				{title: this.getString("business_type"), ref: 'business-type', customSlot: 'input-cards'},
				{title: this.getString("same_company"), ref: 'same-company', switch: true, active: this.copyOption, explain: this.getString('same_company_option'), callback: v => this.copyOption = !!v}
			];
		},
	},
	methods: {
		acceptContractClick() {
			if(this.termAndCondition) {
				this.addBusiness();
			} else {
				this.showNotification("contract-unsigned");
			}
		},
		addBusiness() {

			let businessName = this.$refs["business-name"].currentValue;
			let copyFromBusinessId = this.copyOption ? this.userStore.currBusinessId : null;

			if(businessName.length < 2) {
				this.showNotification("invalid-name");
				return;
			}
			if(!this.address) {
				this.showNotification("error-address");
				return;
			}

			if(!this.businessType) {
				this.showNotification("invalid-business-type");
				return;
			}

			if(!this.termAndCondition) {
				this.$refs["contract-popup"].toggleStatus();
				return;
			}

			this.loadingNewBusiness = true;
			API.init().newBusiness(businessName, this.businessType, this.address.address, JSON.stringify(this.address.data), this.address.lat, this.address.lng, copyFromBusinessId, (res) => {
				if (res && res.result && res.result === "OK" && res.business_id) {
					this.userStore.refreshUserAccount(() => {
						this.userStore.changeBusiness(res.business_id);
						this.loadingNewBusiness = false;
						this.$router.push("/");
					})
                                } else if(res && res.details && res.details === "business_not_allowed") {
                                        this.loadingNewBusiness = false;
                                        this.showNotification("business-not-allowed");
                                } else if(res && res.details && res.details === "stripe_migration_needed") {
                                        this.loadingNewBusiness = false;
                                        this.showNotification("stripe-migration-needed");
                                } else {
					this.loadingNewBusiness = false;
					this.showNotification("generic-fail");
				}
			});


		},
		contractFailed() {
			this.$refs["contract-failed"].cancel();
			this.$refs["contract-popup"].toggleStatus();
		},
		togglingContract(open) {
			if(!open) {
				this.$refs["contract-failed"].cancel();
			}
		}
	},
}
</script>

<style scoped lang="scss">
.new-business-container {
	display: flex;
	flex-direction: column;
	height: 100%;

	&:deep(.card-body) {
		padding: 0 !important;
	}
}

.list-row {
	@include centered;
	justify-content: space-between;
	padding: 10px 0;
}
.text-input, .select-wrapper {
	margin-left: auto;

	@media (max-width: 560px) {
		max-width: 200px;
	}
	@media (max-width: 480px) {
		max-width: 180px;
	}
	@media (max-width: 420px) {
		max-width: 150px;
	}
	@media (max-width: 350px) {
		margin-top: 6px;
		max-width: 100%;
		width: 100%;
	}
}
.list-item-title {
	max-width: calc(100% - 105px);
	font-size: 16px;

	@media (max-width: 560px) {
		font-size: 14px;
	}
	@media (max-width: 400px) {
		font-size: 12px;
	}
	@media (max-width: 350px) {
		max-width: 100%;
		width: 100%;
	}

	&.cards-list-item-title {
		max-width: 200px;
		@media (max-width: 460px) {
			max-width: 100%;
			width: 100%;
			margin-bottom: 10px;
		}
	}
}
.list-item-content {
	@include centered;
	max-width: calc(100% - 200px);
	user-select: none;
	justify-content: space-around;
	gap: 16px;
	flex-wrap: wrap;

	@media (max-width: 460px) {
		max-width: 100%;
		width: 100%;
	}
}
@media (max-width: 350px) {
	.list-row {
		flex-wrap: wrap;

		.number-input {
			margin-top: 6px;
			margin-left: auto;
		}
	}
}

.extra-text {
	width: 100%;
	cursor: pointer;
	p {
		font-size: 14px;
		line-height: 16px;
		color: var(--color-txt-1);
	}
	@media(max-width: 400px) {
		p {
			font-size: 12px;
		}
	}
}

.map-input-container:deep(.input-wrapper) {
	max-width: 100%;
	@media(max-width: 450px) {
		width: 100%;
	}
}



.top-bar {
	display: flex;
	flex-direction: row;
	width: 100%;
	box-shadow: 0 1px 3px var(--color-box-shadow-3);

	.navbar-container {
		z-index: 11;
		width: 100%;
		background-color: var(--color-bg-primary-2);

		.navbar-slot-content {
			padding: 0 10px;

			@media (max-width: 920px) {
				padding: 0 10px 0 2px;
			}
		}

	}
}

.content {
	width: 100%;
	height: calc(100% - 60px);

	.main-content {
		width: 100%;
		height: 100%;
	}
}

@media (max-width: 920px) {
	.top-bar {

		.right-top-bar {
			display: none;
		}

	}
}

</style>
